import { render, staticRenderFns } from "./RecibosList.vue?vue&type=template&id=c3b4a992"
import script from "./RecibosList.vue?vue&type=script&lang=js"
export * from "./RecibosList.vue?vue&type=script&lang=js"
import style0 from "./RecibosList.vue?vue&type=style&index=0&id=c3b4a992&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports